const setAgreedCookies = (value) => { 
  return {
    type: 'SET_AGREED_COOKIES',
    payload: value,
  }
}

export {
  setAgreedCookies,
}